<template>
  <div class="main-ct">
    <p class="quote-paragraph">
      {{ $t('InfinityAI_Statement_Quote') }}
    </p>
    <p class="quote-person">
      {{ $t('InfinityAI_Statement_Quoter') }}
    </p>
    <p class="quote-person-role">
      {{ $t('InfinityAI_Statement_Role') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'MlStudioStatement'
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 60px 100px;
  gap: 20px;
  background-color: #fff;
}

.quote-paragraph {
  color: #1d87c9;
  font-size: 24px;
  font-style: italic;
  font-weight: 600;
  line-height: 32px;
}

.quote-person {
  color: #5c6374;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.quote-person-role {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/components/MlStudioStatement.vue